var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-cadastro" },
    [
      _c("div", { staticClass: "card-header marginTitle" }, [
        _c("h1", [_vm._v(_vm._s(_vm.titleCadastro))])
      ]),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-tabs",
            {
              key: _vm.tabVisual,
              on: { "tab-click": _vm.mudarTab },
              model: {
                value: _vm.tabVisual,
                callback: function($$v) {
                  _vm.tabVisual = $$v
                },
                expression: "tabVisual"
              }
            },
            [
              _vm._l(_vm.tabs, function(tab) {
                return tab.label != "Resumo"
                  ? [
                      _c(
                        "el-tab-pane",
                        { key: tab.name, attrs: { name: tab.name } },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "tab",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(_vm._s(tab.label) + "  "),
                              _vm.tabPossuiErro(tab.label)
                                ? _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "light",
                                        placement: "bottom"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content"
                                        },
                                        [
                                          _vm.getErrosTab(tab.label).length > 0
                                            ? _c("p", [
                                                _c("pre", [
                                                  _vm._v(
                                                    "Preencha todos os campos obrigatórios!"
                                                  )
                                                ])
                                              ])
                                            : _vm._e()
                                        ]
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-warning tooltip-icon"
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  : _vm._e()
              })
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "container-tab" },
            [
              _c(
                "validation-observer",
                { ref: "observer", attrs: { tag: "form" } },
                [
                  _c(
                    "keep-alive",
                    [
                      !_vm.isLoading && _vm.cadastroJson
                        ? _c("router-view", {
                            ref: "childComp",
                            attrs: {
                              cadastro: _vm.cadastroJson,
                              protocolo: _vm.protocolCode,
                              idCadastro: _vm.idCadastro,
                              observer: _vm.$refs.observer,
                              pathDocumentosRemover: _vm.pathDocumentosRemover,
                              tipoCadastro: _vm.tipoCadastro,
                              hasProcesso: _vm.hasProcesso
                            },
                            on: {
                              "add-pratica": function() {
                                return _vm.salvarCadastro(false, false)
                              },
                              "pratica-removida": _vm.onPraticaRemovida
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("app-buttons-cadastro-sicarf", {
        attrs: {
          isPrimeiroPasso: _vm.isPrimeiroPasso,
          isUltimoPasso: _vm.isResumo,
          isIntroPasso: _vm.isIntroPasso,
          showButtonProximo: !_vm.isResumo,
          showButtonSalvar: !_vm.isIntroPasso && !_vm.isResumo
        },
        on: {
          proximo: _vm.proximo,
          salvar: _vm.salvarCadastro,
          voltar: _vm.voltar,
          cancelar: _vm.cancelar,
          finalizar: _vm.finalizarCadastro
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f28fe21", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f28fe21","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Forms/CadastroSicarf/CadastroSicarf.vue
// module id = null
// module chunks = 